import {Event as Event_V3} from '@wix/ambassador-events-v3-event/types'
import {getEventDescription} from '@wix/wix-events-commons-statics'
import React from 'react'
import s from './description.scss'

interface DescriptionProps {
  event: wix.events.Event | Event_V3
}

export const Description = ({event}: DescriptionProps) =>
  getEventDescription(event) ? (
    <div className={s.description} data-hook="ev-list-item-description">
      {getEventDescription(event)}
    </div>
  ) : null
